import React, {
  useState,
  HtmlHTMLAttributes,
  ButtonHTMLAttributes,
  useCallback,
} from "react";

import { Container, DescriptionAnimal } from "./styles";
import image from "../../assets/jpg/no_image.jpg";
import { IAnimal, SelectAnimal } from "../../modules/animals/interface";
import { useTranslate } from "../../hooks/useTranslate";
import { ControlCheckbox } from "../Checkbox";

type ContainerTypes =
  | ButtonHTMLAttributes<HTMLButtonElement>
  | HtmlHTMLAttributes<HTMLDivElement>;

type AnimalProps = {
  editable?: boolean;
  animal: IAnimal;
  handleClick?: (data: SelectAnimal) => void;
  as?: React.ElementType;
} & ContainerTypes;

const ItemAnimal = ({
  animal,
  editable = false,
  handleClick,
  ...props
}: AnimalProps) => {
  const { translate } = useTranslate();

  const [checked, setChecked] = useState(animal?.selected ?? false);

  const onChangeCheked = useCallback(() => {
    console.log("ok");

    if (handleClick != null) {
      handleClick({
        id: animal.id,
        value: !checked,
      });
      setChecked(!checked);
    }
  }, [animal.id, checked, handleClick]);

  return (
    <Container
      {...props}
      onClick={() => {
        handleClick?.({
          id: animal.id,
          value: checked,
        });
      }}
    >
      <DescriptionAnimal>
        <img src={animal?.photo ?? image} alt={animal.name} />
        <div>
          <p>
            {animal.number_identifier} <span>{animal.name}</span>
          </p>
          <p>{`${translate("animals.placeholder_batch")}: ${
            animal.batch?.name ?? translate("global.uninformed")
          } | ${translate("animals.placeholder_flock")}: ${
            animal.flock?.name ?? translate("global.uninformed")
          }`}</p>
        </div>
      </DescriptionAnimal>
      {editable && (
        <ControlCheckbox
          name={`animal-${animal.id}`}
          isChecked={!!animal?.selected}
          onCheck={onChangeCheked}
        />
      )}
    </Container>
  );
};

export { ItemAnimal };
